import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "container-fluid pt-4 pb-5",
  id: "Questions"
}
const _hoisted_2 = { class: "row mt-5 d-flex flex-row justify-content-center align-items-center" }
const _hoisted_3 = { class: "inner col-12 col-lg-11 col-xl-10 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"row d-flex flex-column flex-lg-row justify-content-center align-items-center top\"><p class=\"col-12 col-lg-3 mb-0 title\"><span class=\"number\">2. </span><span>Preguntas principales</span></p><div class=\"col-12 col-lg-1 mt-2 mb-4 my-lg-0 d-flex justify-content-center align-items-center\"><div class=\"line\"></div></div><p class=\"col-11 col-lg-8 mb-0 text text-center text-lg-start\">Las preguntas principales son aquellas que se consideran más relevantes para reflejar el conjunto de creencias, valores, actitudes y prácticas que estructuran y modelan la relación de las personas en México con el poder público, con diferentes formas asociativas y de participación y en la relación con otros individuos.</p></div>", 1)
const _hoisted_5 = { class: "row col-12 mt-5 d-flex flex-row justify-content-center align-items-center mid" }
const _hoisted_6 = { class: "col-12 topic" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "title mb-0" }, "Tema", -1)
const _hoisted_8 = { class: "row col-12 mt-5 d-flex flex-row justify-content-between align-items-center sub" }
const _hoisted_9 = { class: "col-12 col-lg-8 question" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "title mb-0" }, "Pregunta", -1)
const _hoisted_11 = { class: "d-none d-lg-block col-3 explore" }
const _hoisted_12 = { class: "row col-12 my-4 mx-0 px-5 d-flex justify-content-center align-items-center" }
const _hoisted_13 = { class: "col-12 col-lg-3 switch d-flex flex-row justify-content-center align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Total", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Porcentaje", -1)
const _hoisted_16 = { class: "row chart col-12 mx-0 px-2 px-md-4" }
const _hoisted_17 = {
  key: 0,
  class: "text-start",
  style: {"font-size":"12px"}
}
const _hoisted_18 = {
  key: 1,
  class: "text-start",
  style: {"font-size":"12px"}
}
const _hoisted_19 = {
  key: 0,
  class: "row mt-5 col-11 end d-flex d-lg-none"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 py-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Te invitamos a explorar más sobre estos datos en la versión de escritorio de esta plataforma.")
], -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Chart = _resolveComponent("Chart")!
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_VueMultiselect, {
              class: "select",
              ref: "mainTopic",
              modelValue: _ctx.currentMainTopic,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentMainTopic) = $event)),
              options: _ctx.sections,
              "show-labels": false,
              onSelect: _ctx.changeMainTopic,
              placeholder: "Selecciona un tema",
              label: "title"
            }, null, 8, ["modelValue", "options", "onSelect"]),
            _createVNode(_component_v_icon, {
              class: "arrow",
              name: "fa-caret-down",
              scale: "2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.mainTopic.activate()))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_VueMultiselect, {
              class: "select",
              ref: "mainQuestion",
              modelValue: _ctx.currentMainQuestion,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentMainQuestion) = $event)),
              onSelect: _ctx.changeMainQuestion,
              options: _ctx.mainQuestions,
              "show-labels": false,
              placeholder: "Selecciona una pregunta",
              label: "NOMBRE_CAMPO"
            }, null, 8, ["modelValue", "onSelect", "options"]),
            _createVNode(_component_v_icon, {
              class: "arrow",
              name: "fa-caret-down",
              scale: "2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.mainQuestion.activate()))
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              class: "btn text-uppercase px-4 py-3",
              to: "/",
              href: "#Explore"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Explora y compara datos")
              ]),
              _: 1
            })), [
              [_directive_smooth_scroll]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_Toggle, {
              class: "mx-3",
              modelValue: _ctx.isMainPercentage,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isMainPercentage) = $event)),
              onChange: _ctx.changeIsMainPercentage
            }, null, 8, ["modelValue", "onChange"]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Chart, {
            parent: "questions",
            chart: "bars"
          }),
          (_ctx.selectedMainQuestion.NEMONICO ? _ctx.selectedMainQuestion.NEMONICO.includes('AP6_3_') : false)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, "* El porcentaje se calcula a partir de las personas que afirman haber participado alguna vez en la vida en la organización respectiva de la pregunta"))
            : _createCommentVNode("", true),
          (_ctx.selectedMainQuestion.NEMONICO ? _ctx.adultQuestions.includes(_ctx.selectedMainQuestion.NEMONICO) : false)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, "* Pregunta que aplica solo para mayores de edad (18 años y más)"))
            : _createCommentVNode("", true)
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}